
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const expansionOpportunityChallenge: Challenge = {
  id: 'expansion-opportunity',
  title: 'Major Expansion Opportunity',
  description: 'A competitor is selling their operation at a competitive price. This could be a chance to significantly expand.',
  options: [
    {
      text: 'Acquire the entire operation',
      outcome: 'The ambitious acquisition dramatically increased your scale but required significant integration work.',
      kpiEffects: {
        profitMargin: -6,
        efficiency: -4,
        uptime: -3,
        energyCost: -0.005
      },
      experienceGain: 50,
      skillUnlock: skills.find(s => s.id === 'strategic-planning')
    },
    {
      text: 'Cherry-pick their best equipment',
      outcome: 'You selectively purchased their most efficient equipment, improving your operation.',
      kpiEffects: {
        efficiency: 5,
        profitMargin: -3
      },
      experienceGain: 35
    },
    {
      text: 'Decline and focus on organic growth',
      outcome: 'You avoided potential integration issues but missed a major growth opportunity.',
      kpiEffects: {
        uptime: 2,
        profitMargin: 2,
        efficiency: 1
      },
      experienceGain: 20
    }
  ],
  difficulty: 5,
  requiredSkills: ['financial-planning']
}
